/**
 * This is the main entry point of the Javascript.
 * It initializes the necessary components.
 */

import Back from "./components/Back";
// import { setCookie, getCookie } from "./components/cookies";
import Faq from "./components/Faq";
import Header from "./components/Header";
import Sliders from "./components/Sliders";
import Sort from "./components/Sort";
import Cart from "./components/Cart";
import VideoPopup from "./components/VideoPopup";
import Scroll from "./components/Scroll";

document.addEventListener("DOMContentLoaded", () => {
	
    Faq();
    Sliders();
    Header();
    Sort();
    Back();
    Cart();
    VideoPopup();
    Scroll();

    // Display subscription option minimum duration info.
    const selectElement = document.getElementById('bos4w-dropdown-plan');

    if (selectElement) {

        setTimeout(() => {
            const wrapper = document.querySelector('.bos4w-display-dropdown');
            const lockedValue = wrapper?.dataset.subscriptionInterval;
            const selectedPrice = document.getElementById('bos4w-selected-price');
            const selectElement = document.getElementById('bos4w-dropdown-plan');
        
            if (lockedValue) {
                const setSubscriptionValue = () => {
                    for (let option of selectElement.options) {
                        if (option.value === lockedValue) {
                            option.selected = true;
                            selectedPrice.value = option.dataset.price;
                            jQuery(selectElement).trigger('change');
                            break;
                        }
                    }
                    updateSubscriptionInfo();
                };
            
                setSubscriptionValue();
            
                jQuery(document).on('found_variation', function () {
                    setTimeout(setSubscriptionValue, 200);
                });
            
                selectElement.style.pointerEvents = 'none';
                selectElement.style.opacity = '0.5';
            }
        }, 1000);


        const infoElement = document.createElement('p');
        infoElement.id = 'subscription-info';
        infoElement.style.marginTop = '10px';
        selectElement.insertAdjacentElement('afterend', infoElement);
    
        const multipliers = {
            1: 4,
            2: 4,
            3: 4,
            4: 4,
            5: 4,
            6: 4
        };
    
        const calculateEndDate = (daysToAdd) => {
            const currentDate = new Date();
            currentDate.setDate(currentDate.getDate() + daysToAdd + 2);
            return currentDate.toISOString().split('T')[0];
        };
    
        const updateSubscriptionInfo = () => {
            const selectedOption = selectElement.options[selectElement.selectedIndex];
            const match = selectedOption?.value.match(/(\d+)_week/);
    
            if (match) {
                const weeks = parseInt(match[1], 10);
                const multiplier = multipliers[weeks] || 4;
                const totalWeeks = Math.ceil(weeks * multiplier);
                const totalDays = totalWeeks * 7;
                const endDate = calculateEndDate(totalDays);
                let weekTitle = 'tygodni';

                if(totalWeeks == 1) {
                    weekTitle = 'tydzień';
                } else if(totalWeeks > 1 && totalWeeks < 5) {
                    weekTitle = 'tygodnie';
                }
                infoElement.textContent = `Minimalny okres subskrypcji to ${totalWeeks} ${weekTitle} (do ${endDate})`;
    
                const hiddenInput = document.getElementById('minimal_subscription_period');
                if (hiddenInput) {
                    hiddenInput.value = endDate;
                }
            } else {
                infoElement.textContent = 'Wybierz poprawną opcję subskrypcji.';
            }
        };
    
        updateSubscriptionInfo();
    
        selectElement.addEventListener('change', updateSubscriptionInfo);
    }
    
    const typeSwitch = document.querySelectorAll('.single-product-top-wrapper .woocommerce-product-switch-type__wrapper-item');

    if(typeSwitch) {
        typeSwitch.forEach(element => {
            element.addEventListener('click', function() {
                const simpleVariation = document.querySelector('.bos4w-display-options label[for="bos4w-one-time"]');
                const subVariation    = document.querySelector('.bos4w-display-options label[for="bos4w-subscribe-to"]');
                const subWrappersingl = document.querySelector('.bos4w-display-wrap');

                typeSwitch.forEach(typeElement => {
                    typeElement.classList.remove('active');
                })

                this.classList.add('active');

                if(this.dataset.type == 'subscription') {
                    subVariation.click();
                    subWrappersingl.classList.add('active');
                } else if(this.dataset.type === 'simple') {
                    simpleVariation.click();
                    subWrappersingl.classList.remove('active');
                }
            })
        });
    }

    const asideItems = document.querySelectorAll('.how-to-use__tabs-aside-item');
    const valueItems = document.querySelectorAll('.how-to-use__tabs-values-item');

    if(asideItems) {
        asideItems.forEach(function(asideItem) {
            asideItem.addEventListener('click', function() {
                const tabName = this.getAttribute('data-tab-name');
    
                asideItems.forEach(function(item) {
                    item.classList.remove('active');
                });
    
                if(valueItems) {
                    valueItems.forEach(function(item) {
                        item.classList.remove('active');
                    });
                }
    
                this.classList.add('active');

                const allTabsValues = document.querySelectorAll(`.how-to-use__tabs-values-item[data-tab-name="${tabName}"]`);

                if(allTabsValues) {
                    allTabsValues.forEach(element => {
                        element.classList.add('active')
                    });
                }
            });
        });
    }

    const topTabs = document.querySelectorAll('.custom-tabs__top-tab');
    const bottomValues = document.querySelectorAll('.custom-tabs__bottom-value');

    if(topTabs) {
        topTabs.forEach(function(tab) {
            tab.addEventListener('click', function() {
                const tabName = this.getAttribute('data-tab-name');
    
                topTabs.forEach(function(item) {
                    item.classList.remove('active');
                });
    
                bottomValues.forEach(function(item) {
                    item.classList.remove('active');
                });
    
                this.classList.add('active');
                document.querySelector(`.custom-tabs__bottom-value[data-tab-name="${tabName}"]`).classList.add('active');
            });
        });
    }

    const newsletterForm = document.querySelector('.tnp-subscription form');
    const infoElement = document.querySelector('.custom-form-send-info');
    
    if (newsletterForm && infoElement) {
        // Tworzenie loadera
        const loader = document.querySelector('.newsletter__wrapper-text-form-shortcode-loader');
    
        newsletterForm.addEventListener('submit', function(e) {
            e.preventDefault();
    
            const formData = new FormData(this);
    
            infoElement.classList.remove('success', 'error');
            infoElement.textContent = '';
            if(loader) {
                loader.classList.add('active');
            }
    
            fetch(this.action, {
                method: 'POST',
                body: formData
            })
            .then(response => response.text())
            .then(data => {
                console.log(data);
                infoElement.textContent = 'Formularz wysłany pomyślnie!';
                infoElement.classList.add('success');
            })
            .catch(error => {
                console.error('Błąd:', error);
                infoElement.textContent = 'Wystąpił błąd podczas wysyłania formularza.';
                infoElement.classList.add('error');
            })
            .finally(() => {
                loader.classList.remove('active');
            });
        });
    }
    
    const menuTitle = document.querySelector('.products-list__wrapper-sidebar-menu-title');
    const menuContainer = document.querySelector('.products-list__wrapper-sidebar-menu-content');
    const menuIcon = document.querySelector('.products-list__wrapper-sidebar-menu-title-icon');

    if(menuTitle) {
        menuTitle.addEventListener('click', function () {
            if (menuContainer.style.maxHeight) {
                // Jeżeli menu jest otwarte, to je zamykamy
                menuContainer.style.maxHeight = null;
                menuIcon.classList.remove('open');
            } else {
                // Obliczamy pełną wysokość menu i ustawiamy ją
                menuContainer.style.maxHeight = menuContainer.scrollHeight + "px";
                menuIcon.classList.add('open');
            }
        });
    }
    
    const navigationTitle = document.querySelector('.navigation-element-title');
    const navigationWrapper = document.querySelector('.navigation-submenu');
    const navigationIcon = document.querySelector('.navigation-element-title-icon');

    if(navigationTitle) {
        navigationTitle.addEventListener('click', function () {
            console.log(navigationWrapper)
            if (navigationWrapper.style.maxHeight) {
                // Jeżeli menu jest otwarte, to je zamykamy
                navigationWrapper.style.maxHeight = null;
                navigationIcon.classList.remove('open');
            } else {
                // Obliczamy pełną wysokość menu i ustawiamy ją
                navigationWrapper.style.maxHeight = navigationWrapper.scrollHeight + "px";
                navigationIcon.classList.add('open');
            }
        });
    }


    const filtersTitle = document.querySelector('.blog__sidebar-title');
    const filtersContainer = document.querySelector('.blog__sidebar-content');
    const filtersIcon = document.querySelector('.blog__sidebar-title-icon');
    const allEmptyLinks         = document.querySelectorAll('a[href="#"]');
    const allNotEmptyLinks      = document.querySelectorAll('a[href^="#"]');

    if(filtersTitle) {
        filtersTitle.addEventListener('click', function () {
            if (filtersContainer.style.maxHeight) {
                // Jeżeli menu jest otwarte, to je zamykamy
                filtersContainer.style.maxHeight = null;
                filtersIcon.classList.remove('open');
            } else {
                // Obliczamy pełną wysokość menu i ustawiamy ją
                filtersContainer.style.maxHeight = filtersContainer.scrollHeight + "px";
                filtersIcon.classList.add('open');
            }
        });
    }

    if(allEmptyLinks) {
        allEmptyLinks.forEach(link => {
            link.addEventListener('click', function(event) {
                event.preventDefault();
            });
        });
    }
    // Scroll smoothly to element with ID
    if (allNotEmptyLinks) {
        allNotEmptyLinks.forEach(anchor => {
            anchor.addEventListener('click', function (event) {
                event.preventDefault();

                const targetId = this.getAttribute('href');
                if (targetId && targetId.startsWith('#') && targetId.length > 1) {
                    const targetElement = document.querySelector(targetId);
                    if (targetElement) {
                        const yOffset = 0; // Odstęp 100px od góry
                        const yPosition = targetElement.getBoundingClientRect().top + window.pageYOffset + yOffset;

                        window.scrollTo({
                            top: yPosition,
                            behavior: 'smooth'
                        });
                    }
                }
            });
        });
    }

});
